<template>
  <div class="inline-flex items-center">
    <div class="rounded-md" :class="bgClasses">
      <Box class="inline-flex" padding-y="xxsmall" padding-x="xsmall">
        <Typography :color="`${color}-dark`" :variant="textVariant" class="whitespace-nowrap">
          {{ text }}
        </Typography>
      </Box>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { Box, Typography } from '@aryeo/runway'

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  textVariant: {
    type: String,
    default: 'label'
  },
  color: {
    type: String,
    default: 'success'
  }
})

const bgClasses = {
  'bg-amber-100': props.color === 'warning',
  'bg-blue-100': props.color === 'info',
  'bg-emerald-100': props.color === 'success',
  'bg-indigo-100': props.color === 'primary',
  'bg-red-100': props.color === 'danger',
  'bg-gray-100': props.color === 'disabled'
}
</script>
